import React from "react";
import loaderImg from "../../assests/loader.gif";
import classes from "./Loader.module.css";

const Loader = () => {
  return (
    <div className={classes.backdrop}>
      <div className={classes.loaderWrapper}>
        <img src={loaderImg} alt="loader image" className={classes.loaderImg} />
      </div>
    </div>
  );
};

export default Loader;